export interface ICoordate {
  lat: number,
  lng: number
}
